export enum StudentApplicationStatusEnum {
    ALL = 'ALL',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    SENT_FOR_APPROVAL = 'SENT_FOR_APPROVAL',
    SENT_FOR_REVISION = 'SENT_FOR_REVISION'
}